// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import {
  Button,
  ButtonComposed,
  Link,
  modal,
  itemList,
} from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
import { processingUser } from "model/gql/mutations";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./RemoveProcessingUserAccess.m.scss";

const CreateUser = itemList.MutationFactory(processingUser.access.remove);

@themr("@lifepay/RemoveUserAccess", styles)
export default class RemoveUserAccess extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    onSuccess: PropTypes.func,
    username: PropTypes.string,
    accessId: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: null,
      submitButtonState: "normal",
    };
  }

  handleInput = ({ id, value }) => {
    this.setState({ [id]: value });
  };

  render() {
    const { theme, username, accessId, onSuccess } = this.props;
    const { loading, error, submitButtonState } = this.state;
    return (
      <modal.ModalController>
        {({ isOpen, close, open }) => {
          return (
            <React.Fragment>
              <div className={classnames(theme.control)}>
                <Button type={"alt"} size={"small"} onClick={open}>
                  {"Удалить доступ"}
                </Button>
              </div>
              <modal.ModalBox
                isOpen={isOpen}
                close={() => (!loading ? close() : null)}
                theme={{
                  inner: theme.modal,
                }}
              >
                <CreateUser>
                  {(RemoveUserAccess, { data, dataState }) => {
                    const submit = (
                      <div className={classnames(theme.submit)}>
                        <ButtonComposed
                          state={submitButtonState}
                          disabled={submitButtonState !== "normal"}
                          type={"main"}
                          size={"small"}
                          text={"Подтвердить"}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            this.setState({
                              loading: true,
                              submitButtonState: "loading",
                            });
                            RemoveUserAccess({
                              variables: {
                                username,
                                id: accessId,
                              },
                              update: (proxy, response) => {
                                this.setState({
                                  loading: false,
                                  submitButtonState: "normal",
                                });
                                onSuccess && onSuccess();
                                close();
                              },
                            }).catch((e) => {
                              this.setState({
                                loading: false,
                                error: e,
                                submitButtonState: "error",
                              });
                            });
                          }}
                        >
                          {"Удалить"}
                        </ButtonComposed>
                        <Button
                          type={loading ? "disabled" : "alt"}
                          size={"small"}
                          disabled={loading}
                          theme={{
                            wrapper: theme.button,
                          }}
                          onClick={() => {
                            close();
                          }}
                        >
                          {"Отмена"}
                        </Button>
                      </div>
                    );

                    return (
                      <div className={classnames(theme["modal-content"])}>
                        <form
                          autoComplete="off"
                          className={classnames(theme.form)}
                        >
                          <div className={classnames(theme.inputs)}>
                            <div
                              className={classnames(theme.summary)}
                            >{`Удалить доступ`}</div>
                            {error ? (
                              <React.Fragment>
                                <div className={classnames(theme.summary)}>
                                  {error.message}
                                </div>
                                <div className={classnames(theme.summary)}>
                                  <Link
                                    type={"negative"}
                                    withRouter={false}
                                    onClick={() => {
                                      this.setState({
                                        error: null,
                                        submitButtonState: "normal",
                                      });
                                    }}
                                  >
                                    {"Очистить ошибку"}
                                  </Link>
                                </div>
                              </React.Fragment>
                            ) : null}
                          </div>
                          {submit}
                        </form>
                      </div>
                    );
                  }}
                </CreateUser>
              </modal.ModalBox>
            </React.Fragment>
          );
        }}
      </modal.ModalController>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/list-items/ProcessingUser/ProcessingUserAccesses/RemoveProcessingUserAccess/RemoveProcessingUserAccess.js